import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Fisioterapeutas y kinesiólogos que quieren profundizar su dominio técnico', 'Masoterapeutas y terapeutas manuales que quieren agregar una herramienta de alto valor', 'Preparadores físicos y entrenadores deportivos que trabajan con lesiones', 'Estudiantes de ciencias de la salud que quieren adelantarse a su formación', 'Profesionales de la salud que quieren diferenciarse en un mercado competitivo', 'Cualquier persona que quiera entender esta técnica con profundidad real'];
  const notFor = ['Si buscas un truco rápido sin fundamento, este manual no es para ti', 'Si crees que el color de la cinta cambia el efecto terapéutico, primero lee el Módulo 6', 'Si no estás dispuesto a aplicar lo que aprendes, el mejor manual del mundo no te ayudará'];
  return <section className="py-16 px-4 bg-navy-900" data-id="element-17">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-18">
        {/* Para quién es */}
        <FadeIn direction="right" data-id="element-19">
          <h3 className="text-2xl font-heading font-bold text-cream-100 mb-8 pb-4 border-b border-gold-500/30" data-id="element-20">
            Para quién es este manual:
          </h3>
          <ul className="space-y-6" data-id="element-21">
            {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-22">
                <div className="bg-gold-500/10 p-1 rounded-full mr-4 mt-1 flex-shrink-0" data-id="element-23">
                  <Check className="w-5 h-5 text-gold-500" data-id="element-24" />
                </div>
                <span className="text-cream-200 text-lg" data-id="element-25">{item}</span>
              </li>)}
          </ul>
        </FadeIn>

        {/* Para quién no es */}
        <FadeIn direction="left" delay={0.2} data-id="element-26">
          <h3 className="text-2xl font-heading font-bold text-cream-100 mb-8 pb-4 border-b border-red-500/30" data-id="element-27">
            Para quién NO es:
          </h3>
          <ul className="space-y-6" data-id="element-28">
            {notFor.map((item, index) => <li key={index} className="flex items-start opacity-80" data-id="element-29">
                <div className="bg-red-500/10 p-1 rounded-full mr-4 mt-1 flex-shrink-0" data-id="element-30">
                  <X className="w-5 h-5 text-red-400" data-id="element-31" />
                </div>
                <span className="text-cream-200 text-lg" data-id="element-32">{item}</span>
              </li>)}
          </ul>
        </FadeIn>
      </div>
    </section>;
}